import React, { useState, useEffect } from 'react';
import { Form, FormGroup, Input, Button, Label, InputGroup, InputGroupText, Spinner } from 'reactstrap';
import { useTranslation } from "react-i18next";
import { toast, ToastContainer } from 'react-toastify';
import { useNavigate, Link } from "react-router-dom";
import axios from 'axios';
import { FiMail, FiChevronRight, FiArrowLeft } from 'react-icons/fi';
import NoSesssionAuthPage from '../../Layouts/Shared/_NoSesssionAuthPage';

const BRAND_COLOR = "#013682";

export default function ResetPassword1() {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const [email, setEMail] = useState('');
    const [data, setData] = useState(null);
    const [apiCalled, setApiCalled] = useState(false);

    // Mantık korundu: API yanıtına göre yönlendirme veya hata gösterme
    useEffect(() => {
        if (data) {
            setApiCalled(false);
            if (data?.isSucceed === true) {
                toast.success(t('api.default.service.response.succeded'), { autoClose: 1000 });
                sessionStorage.removeItem("currentSession");
                setTimeout(() => {
                    navigate('/reset-password-2');
                }, 1500);
            } else {
                data?.messages?.forEach(item =>
                    toast.error(item.message, { autoClose: 5000 })
                );
            }
        }
    }, [data, t, navigate]);

    const callResetPass1 = (e) => {
        if (e) e.preventDefault();
        setApiCalled(true);

        const requestBody = { email: email };
        axios.defaults.headers.common["X-User-Language"] = t('language')?.toUpperCase();
        const ApiGateway = process.env.REACT_APP_API_URL;

        axios.post(ApiGateway + '/access/login/resetpass/step1', requestBody)
            .then(response => {
                setData(response.data);
            })
            .catch(error => {
                console.error(error);
                toast.error(t('api.default.service.response.error'));
                setApiCalled(false);
            });
    };

    return (
        <NoSesssionAuthPage title={t('pages.reset-password-1.title')}>
            <ToastContainer />

            {/* Üst Başlık Bölümü - Tema ile uyumlu */}
            <div className="text-center text-lg-start mb-5">
                <h2 className="fw-bold mb-2" style={{ color: BRAND_COLOR }}>
                    {t('pages.reset-password-1.header')}
                </h2>
                <p className="text-muted">
                    {t('pages.reset-password-1.description') || 'Şifrenizi sıfırlamak için kayıtlı e-posta adresinizi girin.'}
                </p>
            </div>

            <Form onSubmit={callResetPass1}>
                {/* Email Alanı - LoginPage ile aynı InputGroup yapısı */}
                <FormGroup className="mb-4">
                    <Label className="small fw-bold text-uppercase text-secondary">
                        {t('pages.reset-password-1.form.label.email')}
                    </Label>
                    <InputGroup className="corporate-input-group">
                        <InputGroupText className="bg-transparent border-end-0">
                            <FiMail size={18} className="text-muted" />
                        </InputGroupText>
                        <Input
                            type="email"
                            className="border-start-0 ps-0"
                            placeholder={t('pages.reset-password-1.form.placeholder.email')}
                            onChange={e => setEMail(e.target.value)}
                            onKeyDown={e => e.key === 'Enter' && callResetPass1()}
                            required
                        />
                    </InputGroup>
                </FormGroup>

                <div className="d-flex justify-content-between align-items-center mb-4">
                    <Link to="/login" className="small text-decoration-none fw-bold d-flex align-items-center" style={{ color: BRAND_COLOR }}>
                        <FiArrowLeft className="me-1" /> {t('pages.reset-password-1.form.label.go-back-login')}
                    </Link>
                </div>

                {/* Submit Butonu - Modernize edilmiş Spinner kullanımı */}
                <Button
                    block
                    size="lg"
                    disabled={apiCalled}
                    style={{ backgroundColor: BRAND_COLOR, borderColor: BRAND_COLOR }}
                    className="shadow"
                    type="submit"
                >
                    {apiCalled ? (
                        <Spinner size="sm" />
                    ) : (
                        <>
                            {t('pages.reset-password-1.form.button.send-otp')} <FiChevronRight className="ms-1" />
                        </>
                    )}
                </Button>
            </Form>
        </NoSesssionAuthPage>
    );
}